<template>
    <div class="container-fluid position-relative">

        <button class="btn-icon icon-caret-left detail-slider-arrow detail-slider-arrow__prev" @click="prev"></button>

        <flickity class="detail-slider" ref="flickity" :options="flickityOptions">
            <div class="detail-slider__item" v-for="img in mainslide">
                <div class="detail-slider__item--img">
                    <img :src="img" alt="House Thumb">
                </div>
            </div>
            <div class="detail-slider__item" v-for="img in slide">
                <div class="detail-slider__item--img">
                    <img :src="img" alt="House Thumb">
                </div>
            </div>
        </flickity>

        <button class="btn-icon icon-caret-right detail-slider-arrow detail-slider-arrow__next" @click="next"></button>

    </div>
</template>

<script>
    import Flickity from 'vue-flickity';

    export default {
        components: {
            Flickity,
        },
        data() {
            return {
                flickityOptions: {
                    prevNextButtons: false,
                    contain: true,
                    wrapAround: true
                }
            }
        },
        methods: {
            prev() {
                this.$refs.flickity.previous();
            },
            next() {
                this.$refs.flickity.next();
            }
        },
        props:{
            mainslide: Array,
            slide: Array
        }
    }
</script>
